import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CommonCloudStudioModule, ENVIRONMENT, } from 'common-cloudstudio';
import { IncidentService } from '../services/incident.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '../../shared/shared.module';
import { IncidentFileComponent } from './incident-file.component';
import { incidentFileRoutes } from './incident-file.routes';
import { IncidentSharedModule } from '../incident-shared/incident-shared.module';

declare var environment;

export function environmentFactory(): any {
  return environment;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    incidentFileRoutes,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    BsDropdownModule,
    SharedModule,
    IncidentSharedModule,
  ],
  exports: [IncidentFileComponent],
  declarations: [IncidentFileComponent ],
  providers: [IncidentService, { provide: ENVIRONMENT, useFactory: environmentFactory },],

})
export class IncidentFileModule { }
